import { REGEX_CONFIG } from 'app/shared/utils/regex-utils';
import { maxLength, pattern } from '../core/validator-builders';
import type { ValidationRule } from '../models/validator-models';

const EMAIL_RECIPIENT_MAX_LENGTH = 40;
const SMS_RECIPIENT_MAX_LENGTH = 20;
const EMAIL_RECIPIENT_VALIDATION_MESSAGE = 'LOCATION_CARD.EMAIL_RECIPIENT_VALIDATION';
const SMS_RECIPIENT_VALIDATION_MESSAGE = 'LOCATION_CARD.SMS_RECIPIENT_VALIDATION';
const SMS_RECIPIENT_PATTERN = /^(?:\+?[0-9]+)?$/;

export function getEmailRecipientValidators(): ValidationRule[] {
    return [
        maxLength({ value: EMAIL_RECIPIENT_MAX_LENGTH }),
        pattern({
            value: REGEX_CONFIG.strictEmailPattern,
            message: EMAIL_RECIPIENT_VALIDATION_MESSAGE,
        }),
    ];
}

export function getSmsRecipientValidators(): ValidationRule[] {
    return [
        maxLength({ value: SMS_RECIPIENT_MAX_LENGTH }),
        pattern({
            value: SMS_RECIPIENT_PATTERN,
            message: SMS_RECIPIENT_VALIDATION_MESSAGE,
        }),
    ];
}
